interface MetricBarProps {
    value: number;
    min?: number;
    max?: number;
    decimals?: number;
    suffix?: string;
    thresholds?: {
        excellent: number;
        good: number;
        fair: number;
    };
}

const MetricBar = ({ value, min = 0, max = 100, decimals = 0, suffix = "", thresholds }: MetricBarProps) => {
    // Default thresholds based on scale - using percentage of range
    const defaultThresholds = thresholds || {
        excellent: min + (max - min) * 0.85,
        good: min + (max - min) * 0.7,
        fair: min + (max - min) * 0.5,
    };

    // Ensure value is within range
    const clampedValue = Math.min(max, Math.max(min, value));

    // Calculate percentage for bar width
    const percentage = ((clampedValue - min) / (max - min)) * 100;

    // Calculate colors based on value
    const getColor = (val: number) => {
        if (val >= defaultThresholds.excellent) return "bg-emerald-500";
        if (val >= defaultThresholds.good) return "bg-green-400";
        if (val >= defaultThresholds.fair) return "bg-yellow-400";
        return "bg-red-400";
    };

    // Format display text
    const displayText = `${clampedValue.toFixed(decimals)}${suffix}`;

    return (
        <div className="w-full h-full flex items-start py-2">
            <div className="w-full h-6 bg-gray-100 rounded overflow-hidden relative mx-2">
                <div className={`h-full rounded transition-all duration-300 ${getColor(clampedValue)}`} style={{ width: `${percentage}%` }} />
                <div className="absolute inset-0 flex items-center justify-center text-sm font-medium">
                    <span className="drop-shadow-sm font-semibold">{displayText}</span>
                </div>
            </div>
        </div>
    );
};

export default MetricBar;